// @ts-nocheck
import * as React from "react"
import anime from "animejs";

const THEMEURL = window.drupalSettings ? window.drupalSettings.path.themeUrl : 'themes/custom/mx_aguas_firmes_theme';

const textBtn: any = {
    es: {
        sumate: "Súmate",
        desc: "Juntos construyamos<br/>un futuro con agua,<br/>un futuro con vida"
    },
    en: {
        sumate: "Join us",
        desc: "Let’s build together a<br>future with water, a<br>future with life."
    }
}
export default () => {
    const sticky = drupalSettings.react.sticky
    const refSticky = React.useRef<any>(null)
    const refFooter = document.querySelector('#footerPage')
    const [intersected, setIntersected] = React.useState<boolean>(false)
    
    const hideStick = () => {
        const animationParams = (type: string) => {
            return {
                targets: '.button-container',
                opacity: type == 'in' ? 1 : 0,
                scale: type == 'in' ? 1 : 0.7,
                duration: 1000,
                easing: 'easeInOutBack',
            }

        }
        let options = {
            threshold: 0.7
        }
        let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    anime(animationParams('out'))
                    setIntersected(true)                    
                }
                else if (intersected == true) {
                    anime(animationParams('in'))
                }
            });

        }, options)
        observer.observe(refFooter)
    }

    const closeStick = (e) => {
        e.preventDefault()
        e.stopPropagation()
        anime({
            targets: '.button-container',
            scale: 0,
            opacity: 0,
            duration: 2000,
            easing: 'easeOutBack',
        })
    }

    React.useEffect(() => {
        anime({
            targets: '.button-container',
            scale: [0, 1],
            opacity: [0, 1],
            duration: 1000,
            easing: 'easeOutQuad',
            delay: 1000
        })
    }, [])
    
    React.useEffect(() =>{
        hideStick()
    }, [intersected])

    return (
        <div className="button-container" ref={refSticky}>
            <a href={sticky.field_url.url} title={sticky.field_url.title} target="_blank">
                <div className='button'>
                    {/* <img src={`/${THEMEURL}/sources/dist/assets/images/general/stickNew.png`} alt="Sumate" title="Sumate" /> */}
                    <img src={`/${THEMEURL}/sources/dist/assets/images/general/sumate.png`} alt="Sumate" title="Sumate" />
                    <img className="button__close" onClick={closeStick} src={`/${THEMEURL}/sources/dist/assets/images/general/close-stick.png`} alt="Close" title="Close" />
                    <img className="button__hand" src={`/${THEMEURL}/sources/dist/assets/images/general/sumate-hand.gif`} alt="Hand Sumate" title="Hand Sumate" />
                    <span className="button__sumate">{textBtn[window.currentLang].sumate}</span>
                    <span className="button__nube-text" dangerouslySetInnerHTML={{ __html: textBtn[window.currentLang].desc }}></span>
                </div>
            </a>
        </div>
    )
}